<template>
  <div class="entry-form-message">
    <div class="entry-form-message__icon">
      <icon class="rb-button-solid__icon--icon">
        error
      </icon>
    </div>
    <div class="entry-form-message__message">
      <p>{{message}}</p>
      <button @click="handleClick" class="entry-form-message__button">{{buttonText}}</button>
    </div>
  </div>
</template>

<script>
import { ENTRY_FORM_MESSAGES } from './../core/config';
import { CONTENT_BUTTON_ENTRY_VIEW_RESET, CONTENT_PROMPT_UNKOWN } from '../../design-tokens/build/dictionary';

/**
 * Static messages that appear in the preview area of the entry form
 */
export default {
  name: 'entry-form-message',
  props: {
    messageType: {
      type: String
    },
    overrideButtonText: {
      type: String
    }
  },
  // data() {
  //   return {
  //     buttonText: CONTENT_BUTTON_ENTRY_VIEW_RESET
  //   };
  // },
  computed: {
    buttonText() {
      return this.overrideButtonText || CONTENT_BUTTON_ENTRY_VIEW_RESET;
    },
    message() {
      return ENTRY_FORM_MESSAGES[this.messageType] || CONTENT_PROMPT_UNKOWN;
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss">
.entry-form-message {
  text-align: center;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  color: $color-text-file-upload-text;
  max-width: 60%;
  margin: 0 auto;
  .rb-button-solid__icon--icon {
    color: $color-text-upload-icon;
  }

  &__button {
    color: $color-text-file-upload-text;
    background: none;
    border: none;
    text-decoration: underline;
  }
}
</style>
